module.exports = __webpack_public_path__ + "img/prestige-profile-active@3x-en.png";